import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// // // LIST ALL PAGES Tags
export const tagCreate = (params = '') => Http.post('/page-tags', params)
export const tagsList = (params = '') => Http.get(`/page-tags${serialize(params)}`)
export const tagByID = (params = '') => Http.get(`/page-tags/${params}`)
export const tagUpdate = (params = '') => Http.put(`/page-tags/${params.id}`, params)
export const tagDestroy = (params = '') => Http.delete(`/page-tags/${params.id}`)
 